var _g, _g2, _mask, _path, _path2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 82,
    viewBox: "0 0 132 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2419_3380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 30C4 14.536 16.536 2 32 2H100C115.464 2 128 14.536 128 30C128 45.464 115.464 58 100 58H32C16.536 58 4 45.464 4 30Z",
    fill: "#FCFCFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    filter: "url(#filter1_f_2419_3380)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 66,
    rx: 24,
    ry: 8,
    fill: "#888888"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2419_3380",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2C47.464 2 60 14.536 60 30C60 43.3449 50.6637 54.5072 38.167 57.3164L32 68L25.832 57.3164C13.3357 54.5069 4 43.3446 4 30C4 14.536 16.536 2 32 2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 2C47.464 2 60 14.536 60 30C60 43.3449 50.6637 54.5072 38.167 57.3164L32 68L25.832 57.3164C13.3357 54.5069 4 43.3446 4 30C4 14.536 16.536 2 32 2Z",
    fill: "#0094FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.167 57.3164L37.7284 55.3651C37.1832 55.4876 36.7142 55.8326 36.4349 56.3166L38.167 57.3164ZM32 68L30.2679 69C30.6252 69.6188 31.2855 70 32.0001 70C32.7146 70 33.3749 69.6187 33.7321 68.9999L32 68ZM25.832 57.3164L27.5641 56.3164C27.2848 55.8326 26.8158 55.4877 26.2707 55.3651L25.832 57.3164ZM32 2V4C46.3594 4 58 15.6406 58 30H60H62C62 13.4315 48.5685 0 32 0V2ZM60 30H58C58 42.389 49.3324 52.7566 37.7284 55.3651L38.167 57.3164L38.6056 59.2677C51.9951 56.2579 62 44.3009 62 30H60ZM38.167 57.3164L36.4349 56.3166L30.2679 67.0001L32 68L33.7321 68.9999L39.8991 58.3163L38.167 57.3164ZM32 68L33.7321 67L27.5641 56.3164L25.832 57.3164L24.1 58.3164L30.2679 69L32 68ZM25.832 57.3164L26.2707 55.3651C14.6672 52.7563 6 42.3887 6 30H4H2C2 44.3005 12.0043 56.2575 25.3933 59.2677L25.832 57.3164ZM4 30H6C6 15.6406 17.6406 4 32 4V2V0C15.4315 0 2 13.4315 2 30H4Z",
    fill: "white",
    mask: "url(#path-3-inside-1_2419_3380)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 8,
    fill: "#FCFCFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2419_3380",
    x: 0,
    y: 0,
    width: 132,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2419_3380"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2419_3380",
    result: "effect2_dropShadow_2419_3380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2419_3380",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2419_3380",
    x: 0,
    y: 50,
    width: 64,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2419_3380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2419_3380",
    x1: 94.25,
    y1: 30.25,
    x2: 1417.5,
    y2: 1512.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2419_3380",
    x1: 368.666,
    y1: 248.74,
    x2: 1298.75,
    y2: 1422.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2419_3380",
    x1: 1100.25,
    y1: 1014.29,
    x2: 203.704,
    y2: -430.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD35C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopMarker);
export default __webpack_public_path__ + "static/media/stop-marker.a5ff0ad631615f2f49ded935a1d5290c.svg";
export { ForwardRef as ReactComponent };